(function () {
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var suggestions = drawer.querySelector('[data-cart-suggestions]');
  var list = drawer.querySelector('[data-cart-suggestions-list]');
  var controller;
  function update(cart) {
    if (controller) controller.abort();
    suggestions.hidden = true;
    list.replaceChildren();
    if (drawer.dataset.recommendationsEnabled !== 'true' || !cart.items.length) return;
    controller = new AbortController();
    var url = new URL(drawer.dataset.recommendationsUrl, window.location.origin);
    url.searchParams.set('section_id', drawer.dataset.sectionId);
    url.searchParams.set('product_id', cart.items[0].product_id);
    url.searchParams.set('limit', '10');
    url.searchParams.set('intent', 'related');
    var excluded = cart.items.map(function (item) { return String(item.product_id); });
    fetch(url, { signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var seen = new Set(excluded);
        var cards = Array.from(doc.querySelectorAll('[data-suggestion-product]')).filter(function (card) {
          var id = card.dataset.suggestionProduct;
          if (seen.has(id)) return false;
          seen.add(id);
          return true;
        }).slice(0, 4);
        list.replaceChildren.apply(list, cards);
        suggestions.hidden = cards.length === 0;
      }).catch(function () {});
  }
  document.addEventListener('cart:updated', function (event) { update(event.detail); });
  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) drawer.close();
  });
  if (drawer.dataset.initialProduct && drawer.dataset.recommendationsEnabled === 'true') {
    fetch(window.ShopifyRoutes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
      .then(update).catch(function () {});
  }
}());
